import React, { memo } from 'react';
import { useTranslate } from 'react-polyglot';
import ActionButtons from '../actionsDialog/ActionButtons';

const DeleteExp = memo(function DeleteExp(props) {
    const t = useTranslate();
    return (
        <div className='coa-dialog-form coa-dialog-with-action-buttons'>
            <p className='coa-dialog-msg'>{t('experiences.deleteExp.msg')}</p>
            <p className='coa-dialog-msg-body'>{t('experiences.deleteExp.msgBody')}</p>
            <ActionButtons
                cancelText={t('actions.cancel')}
                acceptText={t('actions.delete')}
                acceptVariant="danger"
                onClickCancel={(e) => {
                    e.preventDefault();
                    props.setOpen(false);
                }}
                onClickAccept={(e) => {
                    e.preventDefault();
                    props.actionHandler(props.keyData);
                }
                }
            ></ActionButtons>
        </div>
    )
})


export default DeleteExp
